import { Table } from '@material-ui/core';
import Head from './CustomTableHead';
import Body from './CustomTableBody';

export type Column = {
  id: string;
  label?: string;
  isSort?: boolean;
  Cell?: (val: any, row?: any) => JSX.Element | string;
  width?: any;
};

const CustomTable = ({
  columns,
  rows,
  onRowClick,
  editBaseRoute,
  selectedSort,
  setSelectedSort,
  showCheckbox,
  checkedIds,
  setCheckedIds,
}: any) => (
  <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
    <Head
      columns={columns}
      selectedSort={selectedSort}
      setSelectedSort={setSelectedSort}
      showCheckbox={showCheckbox}
      checkedIds={checkedIds}
      setCheckedIds={setCheckedIds}
      rows={rows}
    />
    <Body
      rows={rows}
      columns={columns}
      editBaseRoute={editBaseRoute}
      onRowClick={onRowClick}
      showCheckbox={showCheckbox}
      checkedIds={checkedIds}
      setCheckedIds={setCheckedIds}
    />
  </Table>
);

export default CustomTable;
